import { useState } from 'react';
import ConsultingFormModal from '../../../components/ConsultingFormModal';
import FreeResourceModal from '../../../components/FreeResourceModal';

export default function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFreeResourceModalOpen, setIsFreeResourceModalOpen] = useState(false);

  const scrollToSelfDiagnosis = () => {
    const selfDiagnosisSection = document.getElementById('self-diagnosis');
    if (selfDiagnosisSection) {
      selfDiagnosisSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToConsulting = () => {
    const consultingSection = document.getElementById('consulting-form');
    if (consultingSection) {
      consultingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section className="relative min-h-[85vh] md:min-h-[85vh] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://static.readdy.ai/image/f2d4f0b55ceaa6c07b19f5a03d25a420/07366b3ab2b45847aa1eb361a85b622c.png')",
            borderRadius: '0 0 50% 50% / 0 0 80px 80px',
            filter: 'saturate(1.2) brightness(1.1)'
          }}
        >
          <div 
            className="absolute inset-0 bg-gradient-to-b from-blue-900/60 via-blue-900/50 to-blue-900/60"
            style={{
              borderRadius: '0 0 50% 50% / 0 0 80px 80px',
              filter: 'saturate(0.3)'
            }}
          ></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 text-center w-full -mt-8 md:-mt-8">
          <div className="space-y-6 sm:space-y-8 md:space-y-10">
            {/* 강 - 메인 타이틀 */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white mb-6 sm:mb-8 md:mb-10 leading-tight tracking-tight px-2">
              <span className="text-white">
                <span className="relative inline-block">
                  점
                  <span className="absolute -top-1.5 sm:-top-2 md:-top-3 lg:-top-4 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 lg:w-3 lg:h-3 bg-white rounded-full"></span>
                </span>
                <span className="relative inline-block">
                  검
                  <span className="absolute -top-1.5 sm:-top-2 md:-top-3 lg:-top-4 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 lg:w-3 lg:h-3 bg-white rounded-full"></span>
                </span>
                부터{' '}
                <span className="relative inline-block">
                  증
                  <span className="absolute -top-1.5 sm:-top-2 md:-top-3 lg:-top-4 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 lg:w-3 lg:h-3 bg-white rounded-full"></span>
                </span>
                <span className="relative inline-block">
                  빙
                  <span className="absolute -top-1.5 sm:-top-2 md:-top-3 lg:-top-4 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 lg:w-3 lg:h-3 bg-white rounded-full"></span>
                </span>
                까지,
              </span>
              <br />
              <span className="relative inline-block pb-2 sm:pb-3 text-white" style={{ marginTop: '12px' }}>
                모든 과정을 함께하겠습니다
                <svg className="absolute bottom-0 left-0 w-full" viewBox="0 0 300 12" preserveAspectRatio="none" style={{ height: '8px' }}>
                  <path 
                    d="M0,6 Q75,3 150,6 T300,6" 
                    fill="none" 
                    stroke="#38bdf8" 
                    strokeWidth="3" 
                    strokeLinecap="round"
                    style={{ 
                      filter: 'url(#marker-blur)',
                      opacity: 0.9
                    }}
                  />
                  <defs>
                    <filter id="marker-blur">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="0.5" />
                    </filter>
                  </defs>
                </svg>
              </span>
            </h1>
            
            {/* 중 - 서브 타이틀 */}
            <div className="space-y-3 sm:space-y-4 md:space-y-5 mb-6 sm:mb-8 md:mb-10">
              <p className="text-base sm:text-xl md:text-2xl lg:text-3xl text-white font-semibold leading-relaxed sm:leading-[3]">
                사고, 과태료, 입찰제한···<br />
                사업장의 손실을 예방하는 가장 현명한 대비책
              </p>
              <div className="w-16 sm:w-20 md:w-24 lg:w-28 h-1.5 bg-white/80 mx-auto rounded-full"></div>
            </div>

            {/* 약 - 서비스 목록 */}
            <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white/90 mb-6 sm:mb-8 md:mb-10 lg:mb-12 font-normal leading-relaxed max-w-6xl mx-auto px-2 break-keep">
              위험성평가 · 근골격계유해요인조사 · 안전보건체계구축 · 유해위험방지계획서 · 안전관리 위탁(대행) · KCs인증
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-5 lg:gap-6 justify-center items-center pt-2 sm:pt-4 px-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="w-full sm:w-auto bg-blue-600 text-white px-8 sm:px-10 md:px-14 lg:px-16 py-4 sm:py-5 md:py-6 lg:py-7 rounded-full text-base sm:text-lg md:text-xl lg:text-2xl font-bold hover:bg-blue-700 transition-all duration-300 shadow-2xl hover:shadow-blue-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                무료 견적받기
              </button>
              <button
                onClick={() => setIsFreeResourceModalOpen(true)}
                className="w-full sm:w-auto bg-white/95 text-blue-600 px-8 sm:px-10 md:px-14 lg:px-16 py-4 sm:py-5 md:py-6 lg:py-7 rounded-full text-base sm:text-lg md:text-xl lg:text-2xl font-bold hover:bg-white transition-all duration-300 shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                업종별 무료 자료 받기
              </button>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-3 sm:bottom-4 md:bottom-6 left-0 right-0 z-20">
          <div className="flex flex-col items-center gap-1.5 sm:gap-2 md:gap-3 mx-auto w-fit animate-bounce">
            <span className="text-white/70 text-sm sm:text-base md:text-lg font-medium">Scroll</span>
            <i className="ri-arrow-down-line text-2xl sm:text-3xl md:text-4xl text-white/80"></i>
          </div>
        </div>
      </section>

      <ConsultingFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <FreeResourceModal isOpen={isFreeResourceModalOpen} onClose={() => setIsFreeResourceModalOpen(false)} />
    </>
  );
}
